var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.981 9.37006C15.045 8.54606 14.5 7.37106 14.5 6.11306C14.5 3.59106 16.718 1.53906 19.445 1.53906C20.801 1.53906 22.069 2.04806 23 2.95106C23.931 2.04806 25.198 1.53906 26.555 1.53906C29.282 1.53906 31.5 3.59106 31.5 6.11306C31.5 7.37006 30.957 8.54406 29.97 9.41706L23 16.5711L15.981 9.37006Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.441 22.9465L37.1 19.2875C37.966 18.4215 37.966 17.0175 37.1 16.1505C36.234 15.2845 34.83 15.2845 33.963 16.1505L31.667 18.4465C28.638 21.4755 26.54 21.0285 24.793 22.7755C23.53 24.0385 23.01 25.8565 23.01 28.4585C23.01 30.7055 23 32.5015 23 32.5015",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 32.5C33.5 31.674 33.752 29.932 36.018 28.032C37.631 26.679 39.239 25.399 41.282 23.355C42.76 21.877 42.586 19.163 43.499 8.66102L43.5 8.71702C43.5 7.49202 42.507 6.49902 41.282 6.49902C40.057 6.49902 39.267 7.34202 39.064 8.71702C38.861 10.092 37.731 17.893 37.731 17.893",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853 32.5015C22.853 32.5015 22.843 30.7055 22.843 28.4585C22.843 25.8565 22.323 24.0385 21.06 22.7755C19.313 21.0285 17.215 21.4755 14.186 18.4465L11.89 16.1505C11.023 15.2845 9.61902 15.2845 8.75302 16.1505C7.88702 17.0175 7.88702 18.4215 8.75302 19.2875L12.412 22.9465",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12252 17.893C8.12252 17.893 6.99252 10.092 6.78952 8.71702C6.58652 7.34202 5.79652 6.49902 4.57152 6.49902C3.34652 6.49902 2.35352 7.49202 2.35352 8.71702L2.35452 8.66102C3.26752 19.163 3.09352 21.877 4.57152 23.355C6.61452 25.399 8.22252 26.679 9.83552 28.032C12.1015 29.932 12.3535 31.674 12.3535 32.5",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIcon);
export default __webpack_public_path__ + "static/media/welcome-icon.f22ff9b97ed35f0430fa81123ede5439.svg";
export { ForwardRef as ReactComponent };